export default {
  namespaced: true,
  state: {
    isOpenViewer: false,
    images: [], // src, name
  },
  getters: {
    getIsOpenViewer: state => state.isOpenViewer,
    getImages: state => state.images,
  },
  mutations: {
    setViewer(state, payload) {
      state.images = payload.images
      state.isOpenViewer = payload.isOpenViewer
    },
    resetViewer(state) {
      state.isOpenViewer = false
      state.images = []
    },
  },
  actions: {
    setViwerData: ({ commit }, payload) => {
      commit('setViewer', payload)
    },
  },
}
